import { motion } from "framer-motion";
import { STEPS, PILLARS } from "@/data/content";
import { Eyebrow, Reveal } from "./Reveal";

export const Process = () => (
  <section id="process" data-testid="process-section" className="grain relative overflow-hidden bg-[var(--ink)] py-24 text-white lg:py-32">
    <div className="absolute -right-32 top-0 h-[480px] w-[480px] rounded-full bg-[var(--blue)]/40 blur-[140px]" />
    <div className="relative mx-auto max-w-[1400px] px-5 sm:px-8">
      <Reveal>
        <Eyebrow light>How it works</Eyebrow>
        <h2 className="mt-5 max-w-3xl font-display text-4xl font-black italic leading-[1] tracking-tight sm:text-5xl lg:text-6xl">
          Three steps from <span className="text-[var(--lime)]">application</span> to funded.
        </h2>
      </Reveal>

      <div className="relative mt-16 grid grid-cols-1 gap-10 md:grid-cols-3 md:gap-8">
        <motion.div
          className="absolute left-0 right-0 top-[38px] hidden h-px origin-left bg-gradient-to-r from-[var(--sky)] via-[var(--green)] to-[var(--lime)] md:block"
          initial={{ scaleX: 0 }}
          whileInView={{ scaleX: 1 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 1.6, ease: [0.22, 1, 0.36, 1] }}
        />
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={0.15 * i}>
            <div data-testid={`process-step-${i + 1}`} className="relative">
              <div className="relative flex h-[76px] w-[76px] items-center justify-center rounded-full border border-white/20 bg-[var(--ink-2)] font-mono text-xl font-bold text-[var(--lime)]">{s.n}</div>
              <h3 className="mt-8 font-display text-2xl font-extrabold italic">{s.title}</h3>
              <p className="mt-3 max-w-sm text-base leading-relaxed text-slate-300">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-24 grid grid-cols-1 gap-px overflow-hidden rounded-[28px] border border-white/10 bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {PILLARS.map((p, i) => (
          <Reveal key={p.k} delay={0.08 * i} y={16}>
            <div data-testid={`pillar-${p.k.toLowerCase()}`} className="group h-full bg-[var(--ink)] p-8 transition-colors duration-500 hover:bg-[var(--ink-2)]">
              <div className="font-mono text-xs uppercase tracking-[0.2em] text-sky-300">{p.k}</div>
              <div className="mt-6 font-display text-2xl font-black italic">{p.v}</div>
              <p className="mt-3 text-sm leading-relaxed text-slate-300">{p.d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
